import React, { useEffect } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";

import { useTranslation } from "react-i18next";

function UserSalesCard({ userData }) {
  const {
    t,
  } = useTranslation();

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Row>
          <Col>
            <Card.Title as="h4" style={{ color: userData.color }}>{`${userData.name}`}</Card.Title>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <tbody>
            {userData.paymentMethods.map((row) => (
              <tr key={row.id}>
                <td>{row.name}</td>
                <td className="align-text-right">{row.total.toFixed(2)}</td>
              </tr>
            ))}
            <tr>
              <td>{t("tables.headers.paid")}</td>
              <td className="align-text-right">{userData.payed.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.discounts")}</td>
              <td className="align-text-right">{userData.discount.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.cancellations")}</td>
              <td className="align-text-right">{userData.cancelled.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.wastagePlural")}</td>
              <td className="align-text-right">{userData.destroyed.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.orders")}</td>
              <td className="align-text-right">{userData.orders}</td>
            </tr>
            <tr>
              <td>TIPS</td>
              <td className="align-text-right">{userData.tips.toFixed(2)}</td>
            </tr>
            <tr key="total">
              <td className="bold">{t("tables.headers.revenue")}</td>
              <td className="bold align-text-right">{userData.turnover.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default UserSalesCard;
